/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadAssignmentSummary
 */
export interface LeadAssignmentSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    role: LeadAssignmentSummaryRoleEnum;
}


/**
 * @export
 */
export const LeadAssignmentSummaryRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON',
} as const;
export type LeadAssignmentSummaryRoleEnum = typeof LeadAssignmentSummaryRoleEnum[keyof typeof LeadAssignmentSummaryRoleEnum];


/**
 * Check if a given object implements the LeadAssignmentSummary interface.
 */
export function instanceOfLeadAssignmentSummary(value: object): value is LeadAssignmentSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function LeadAssignmentSummaryFromJSON(json: any): LeadAssignmentSummary {
    return LeadAssignmentSummaryFromJSONTyped(json, false);
}

export function LeadAssignmentSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAssignmentSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function LeadAssignmentSummaryToJSON(json: any): LeadAssignmentSummary {
    return LeadAssignmentSummaryToJSONTyped(json, false);
}

export function LeadAssignmentSummaryToJSONTyped(value?: LeadAssignmentSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['user_id'],
        'role': value['role'],
    };
}

